export default "__VITE_ASSET__DYM9NAbu__"